<template>
  <sweet-modal ref="modal" overlay-theme="dark">
    <h3>คำตอบที่ตอบผิด</h3>
    <div class="text-left" v-for="(item, index) in questionAnswers" :key="index">
      <h4>{{ index + 1 }}. {{ item.question_text }}</h4>
      <div v-if="item.question_image_url">
        <img :src="item.question_image_url" alt="" class="img-fluid">
      </div>
      <div style="margin: 2rem;">
        <div class="mb-2 d-flex" :class="checkAnswer(item, item.question_answer_1_text, item.question_answer_1_image_url)">
          <div class="mr-3">ก.</div>
          <div>
            <span v-html="convertLineBreaks(item.question_answer_1_text)"></span>
            <div v-if="item.question_answer_1_image_url">
              <img :src="item.question_answer_1_image_url" alt="" class="img-fluid">
            </div>
          </div>
        </div>
        <div class="mb-2 d-flex" :class="checkAnswer(item, item.question_answer_2_text, item.question_answer_2_image_url)">
          <div class="mr-3">ข.</div>
          <div>
            <span v-html="convertLineBreaks(item.question_answer_2_text)"></span>
            <div v-if="item.question_answer_2_image_url">
              <img :src="item.question_answer_2_image_url" alt="" class="img-fluid">
            </div>
          </div>
        </div>
        <div class="mb-2 d-flex" :class="checkAnswer(item, item.question_answer_3_text, item.question_answer_3_image_url)">
          <div class="mr-3">ค.</div>
          <div>
            <span v-html="convertLineBreaks(item.question_answer_3_text)"></span>
            <div v-if="item.question_answer_3_image_url">
              <img :src="item.question_answer_3_image_url" alt="" class="img-fluid">
            </div>
          </div>
        </div>
        <div class="mb-2 d-flex" :class="checkAnswer(item, item.question_answer_4_text, item.question_answer_4_image_url)">
          <div class="mr-3">ง.</div>
          <div>
            <span v-html="convertLineBreaks(item.question_answer_4_text)"></span>
            <div v-if="item.question_answer_4_image_url">
              <img :src="item.question_answer_4_image_url" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </sweet-modal>
</template>

<script>
import axios from 'axios'
import { SweetModal } from 'sweet-modal-vue'

export default {
  name: 'ExaminationModal',
  data () {
    return {
      questionAnswers: []
    }
  },
  components: {
    SweetModal
  },
  methods: {
    openModal (examId) {
      this.fetchData(examId)
      this.$refs.modal.open()
    },
    convertLineBreaks (text) {
      if (text) {
        return text.replace(/\n/g, '<br>')
      }
      return ''
    },
    checkAnswer (answer, text, imageUrl) {
      let textClass = ''
      if (imageUrl) {
        if (answer.question_answer_correct_image_url === imageUrl) {
          textClass = 'text-success'
        } else {
          textClass = 'text-danger'
        }
      } else if (text) {
        if (answer.question_answer_correct_text === text) {
          textClass = 'text-success'
        } else {
          textClass = 'text-danger'
        }
      }
      return textClass
    },
    async fetchData (examId) {
      let { data } = await axios.get(`professional/examinations/${examId}/answers`, { params: { is_correct: 0 } })
      if (!data.error) {
        this.questionAnswers = data.question_answers
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/professional/components/ExaminationModal.vue